import { render } from "./Details.vue?vue&type=template&id=6cb22cc4&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=6cb22cc4&scoped=true&lang=css"
import "./Details.vue?vue&type=style&index=1&id=6cb22cc4&lang=css"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb22cc4"]])

export default __exports__